import type { CityConfig } from "../city-template/types";

export const breckenridgeConfig: CityConfig = {
  city: "Breckenridge",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "breckenridge",
  route: "/cities/breckenridge",
  title: "Emergency Passport Breckenridge, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Breckenridge, Colorado — as fast as 24 hours. Same-day courier processing for Breckenridge, Frisco, Silverthorne, Dillon, and all Summit County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Breckenridge, CO",
  heroSubtitle: "Ski trip to the Alps booked and your passport just expired? Destination wedding in Mexico next week and you can't find your passport? We help Breckenridge residents — from slopeside condo owners to Summit County families to seasonal ski instructors — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Breckenridge%20Colorado%20winter%20mountain%20town%20with%20snow%20capped%20peaks%20and%20colorful%20Victorian%20buildings%20along%20Main%20Street%2C%20the%20Breckenridge%20Ski%20Resort%20slopes%20visible%20behind%20the%20historic%20downtown%20district%2C%20blue%20sky%20with%20scattered%20clouds%20over%20the%20Tenmile%20Range%2C%20charming%20mountain%20architecture%20with%20shops%20and%20restaurants%2C%20fresh%20powder%20snow%20coating%20the%20streets%2C%20crisp%20alpine%20light%20at%20golden%20hour%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20perspective&width=1800&height=700&seq=breckenridge-hero-001&orientation=landscape",
  heroImageAlt: "Breckenridge Colorado mountain town with ski slopes and historic Main Street",
  geoPosition: "39.4817;-106.0384",
  geoPlacename: "Breckenridge, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 80 miles east via I-70 — about 1.5 hours in good conditions",
  },
  nearbyCitiesZips: [
    { name: "Breckenridge", zips: "80424" },
    { name: "Frisco", zips: "80443" },
    { name: "Silverthorne", zips: "80497, 80498" },
    { name: "Dillon", zips: "80435" },
    { name: "Keystone", zips: "80435" },
    { name: "Copper Mountain", zips: "80443" },
    { name: "Blue River", zips: "80424" },
    { name: "Montezuma", zips: "80435" },
    { name: "Alma", zips: "80420" },
    { name: "Fairplay", zips: "80440" },
    { name: "Leadville", zips: "80461" },
    { name: "Vail", zips: "81657, 81658" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Breckenridge international departures via DEN or EGE" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — no need to navigate I-70 mountain corridor to Denver" },
    { icon: "ri-flight-takeoff-line", title: "DEN & EGE Airport Service", desc: "Same-day courier for Denver International and Eagle County Regional airports" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Summit County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Vail, CO", route: "/cities/vail" },
    { name: "Fast passport renewal in Summit County", route: "/cities/breckenridge" },
    { name: "Urgent passport services for Frisco and Dillon", route: "/cities/breckenridge" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Silverthorne and Keystone", route: "/cities/breckenridge" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Breckenridge remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Breckenridge's high-country location — 80 miles from the Colorado Passport Agency via the Eisenhower Tunnel — makes our courier service especially valuable. Skip the I-70 traffic and tunnel backups and let us handle everything.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Summit County, from Breckenridge to Copper Mountain",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Breckenridge and Summit County. From the slopes of Peaks 6–10 to the historic Main Street district, from the Blue River corridor to Baldy Mountain — we serve every neighborhood in Breckenridge and the surrounding mountain communities.",
  nearbyCitiesIntro: "We serve Breckenridge and all nearby Summit County communities including Frisco, Silverthorne, Dillon, Keystone, Copper Mountain, Blue River, and Montezuma. We also serve Alma, Fairplay, and Leadville in the surrounding high country.",
  howItWorksIntro: "Most Breckenridge travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 80 miles to Denver through the Eisenhower Tunnel.",
  mistakesIntro: "Breckenridge is a world-class ski destination with international visitors and seasonal workers from around the globe. Here are the most common passport mistakes we see from Summit County travelers.",
  testimonialsIntro: "Breckenridge travelers — from winter ski vacationers to summer mountain bikers to year-round Summit County locals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Breckenridge, CO? Here are the most common ones we hear from Summit County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Colorado Vital Records (Birth, Death, Marriage)", href: "https://cdphe.colorado.gov/certificates-and-records" },
    { label: "Summit County Clerk & Recorder", href: "https://www.summitcountyco.gov/225/Clerk-Recorder" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Denver (1.5+ hours each way)", "I-70 Eisenhower Tunnel traffic and weather-dependent"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive required — ship from Breckenridge", "Perfect for international ski trips and resort vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Breckenridge travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service available without the I-70 drive to Denver.",
      bullets: ["24–48 hour turnaround available", "DEN and EGE airport departure support", "International ski season expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Breckenridge adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Summit County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Breckenridge residents and Summit County families — including seasonal workers and J-1 visa holders.",
      bullets: ["Acceptance facility scheduling in Frisco or Breckenridge", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Breckenridge residents who lost their passport before international travel — ski season or summer adventure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Summit County families traveling internationally with kids during school breaks.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Breckenridge and Summit County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Breckenridge CO", description: "Urgent passport processing for Breckenridge Colorado travelers with immediate departure needs from DEN or EGE." },
    { name: "Expedited Passport Renewal Breckenridge CO", description: "Fast passport renewal for Breckenridge Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Breckenridge CO", description: "New passport application services for Breckenridge Colorado residents applying for their first passport." },
    { name: "Child Passport Breckenridge CO", description: "Minor passport services for Breckenridge Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michael R.",
      location: "Breckenridge, CO — Peak 8",
      rating: 5,
      text: "Had a ski trip to Chamonix booked and realized my passport expired two weeks before departure. Fast Passport Center got it renewed in 3 days. Dropped documents at UPS in Frisco and everything was seamless. Saved our trip.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Emily K.",
      location: "Silverthorne, CO",
      rating: 5,
      text: "Family trip to Italy over spring break. Needed three passports — one renewal and two first-time for the kids. Done in 5 business days. The courier service is perfect for mountain communities far from Denver.",
      service: "Family Passport Bundle",
    },
    {
      name: "Josh T.",
      location: "Blue River, CO",
      rating: 5,
      text: "Business trip to London with 4 days notice. They walked me through everything and had my passport in 48 hours. Living at 10,000 feet, driving to Denver is not something you want to do in winter.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah M.",
      location: "Breckenridge, CO — Main Street",
      rating: 5,
      text: "Lost my passport during a move between seasonal housing. Had a wedding in Mexico in 10 days. Fast Passport Center replaced it in 3 days. The team was incredibly responsive and professional.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "brk-1",
      name: "Breckenridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "305 S Ridge St",
      city: "Breckenridge",
      state: "CO",
      zip: "80424",
      phone: "(970) 453-2315",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Breckenridge, near Main Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Breckenridge acceptance facility. Appointments required — book well in advance during ski season (November–April). Limited hours during shoulder seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "brk-2",
      name: "Frisco Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "350 Peak One Dr",
      city: "Frisco",
      state: "CO",
      zip: "80443",
      phone: "(970) 668-5797",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Frisco, approximately 9 miles north of Breckenridge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility than Breckenridge with more appointment availability. Good alternative for all Summit County residents. Extended hours.",
      icon: "ri-mail-line",
    },
    {
      id: "brk-3",
      name: "Silverthorne Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 Blue River Pkwy",
      city: "Silverthorne",
      state: "CO",
      zip: "80497",
      phone: "(970) 468-9187",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Silverthorne, approximately 13 miles north of Breckenridge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Silverthorne and Dillon residents. Located near the outlet malls. Good parking availability.",
      icon: "ri-mail-line",
    },
    {
      id: "brk-4",
      name: "Summit County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "208 E Lincoln Ave",
      city: "Breckenridge",
      state: "CO",
      zip: "80424",
      phone: "(970) 453-3470",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Breckenridge downtown, near the Summit County Courthouse",
      website: "https://www.summitcountyco.gov/",
      websiteLabel: "Summit County Clerk",
      notes: "County clerk passport acceptance. May have shorter wait times than post office during peak season. Convenient downtown location.",
      icon: "ri-government-line",
    },
    {
      id: "brk-5",
      name: "Dillon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 Lake Dillon Dr",
      city: "Dillon",
      state: "CO",
      zip: "80435",
      phone: "(970) 468-2341",
      hours: "Mon–Fri: 9:00 AM – 3:30 PM",
      distance: "Dillon, approximately 14 miles north of Breckenridge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Smaller facility serving Dillon and Keystone residents. Limited hours — call ahead to confirm availability. Lake Dillon views.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 1.5hr drive to Denver via I-70 tunnel", fpc: "No — ship from Breckenridge" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "I-70 Tunnel Traffic", agency: "Eisenhower Tunnel backups common", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Peak Ski Season",
      description: "Breckenridge's busiest periods — Christmas, Presidents' Week, and spring break — coincide with peak passport demand. Routine processing takes 8–11 weeks. Start expedited service at least 4 weeks before your ski trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services sometimes produce photos for ski passes rather than passports. Passport photos must be exactly 2×2 inches on a white background — no exceptions. No ski goggles or hats.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Summit County post offices fill during peak tourist seasons. Book 2–3 weeks ahead during ski season. The Frisco Post Office typically has the best availability.",
    },
    {
      icon: "ri-roadster-line",
      title: "Underestimating I-70 Mountain Travel",
      description: "Many Summit County residents attempt the Denver passport agency drive. The Eisenhower Tunnel, Floyd Hill, and weekend ski traffic can turn a 1.5-hour drive into 3+ hours. Our courier service eliminates this hassle entirely.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many European countries require 6 months of passport validity beyond your stay. Breckenridge travelers heading to the Alps or other international ski destinations often discover this requirement too late.",
    },
    {
      icon: "ri-user-location-line",
      title: "Seasonal Worker Documentation Gaps",
      description: "Breckenridge employs thousands of seasonal workers, including J-1 visa holders and international staff. These workers often have complex documentation needs — name changes on foreign documents, expired home-country passports, and work visa requirements.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Breckenridge or Summit County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Breckenridge, Frisco, or Silverthorne." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for high-country documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no I-70 tunnel drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Breckenridge address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Breckenridge, CO?", a: "Fast Passport Center offers emergency passport processing in Breckenridge, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 80-mile drive over the Eisenhower Tunnel to the Colorado Passport Agency." },
    { q: "Does Breckenridge have its own passport agency?", a: "No — Breckenridge does not have a regional passport agency. The nearest is the Colorado Passport Agency (80 miles east via I-70, through the Eisenhower Tunnel). Fast Passport Center's courier service means Summit County residents never need to deal with I-70 mountain corridor traffic." },
    { q: "What's the closest airport to Breckenridge for international flights?", a: "Denver International Airport (DEN) is approximately 100 miles east of Breckenridge — about 2 hours in good conditions. Eagle County Regional Airport (EGE) is approximately 60 miles west but offers limited international service. All Breckenridge international travelers should plan connections through DEN." },
    { q: "Can you serve seasonal workers and J-1 visa holders in Breckenridge?", a: "Absolutely. Fast Passport Center serves Breckenridge's large seasonal workforce including international staff on J-1 visas. We understand the unique documentation challenges seasonal workers face and can help navigate both U.S. and home-country passport requirements." },
    { q: "What if I live in Frisco, Silverthorne, Dillon, or Keystone?", a: "Absolutely. Fast Passport Center serves all of Summit County including Frisco, Silverthorne, Dillon, Keystone, Copper Mountain, Blue River, and Montezuma. Our service works the same way everywhere — ship your documents and we handle the rest." },
    { q: "How much does an expedited passport cost in Breckenridge, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Breckenridge?", a: "City Market (400 N Park Ave) offers passport photo services. The UPS Store in Frisco and Walgreens in Silverthorne also provide passport photos. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve second-home owners in Summit County?", a: "Yes. Fast Passport Center serves both full-time Summit County residents and second-home owners. If you split your time between Breckenridge and another location, we can work with whichever address is most convenient for document delivery." },
  ],
  photoLocations: [
    { name: "City Market — Breckenridge", address: "400 N Park Ave, Breckenridge, CO 80424", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Frisco", address: "842 N Summit Blvd, Frisco, CO 80443", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Silverthorne", address: "715 Blue River Pkwy, Silverthorne, CO 80497", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Silverthorne", address: "246 Rainbow Dr, Silverthorne, CO 80498", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Frisco (Summit County)", address: "37 Peak One Dr, Frisco, CO 80443", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Summit County residents. REAL ID and driver's license renewals. Approximately 10 miles from Breckenridge.", featured: true },
    { name: "DMV — Eagle (Eagle County)", address: "500 Broadway, Eagle, CO 81631", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for western Summit County residents. REAL ID processing available. Approximately 45 miles from Breckenridge.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "100 miles east of Breckenridge via I-70",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Approximately 2-hour drive from Breckenridge in good conditions. I-70 mountain corridor and Eisenhower Tunnel traffic can add significant time.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "EGE",
      name: "Eagle County Regional Airport",
      distance: "60 miles west of Breckenridge via I-70",
      address: "219 Eldon Wilson Rd, Gypsum, CO 81637",
      note: "Regional airport serving Vail Valley. Winter seasonal international flights available. Year-round domestic connections to major hubs. Approximately 1-hour drive from Breckenridge.",
      flightUrl: "https://www.eaglecounty.us/airport",
      flightLabel: "EGE Flight Info",
      featured: false,
    },
    {
      code: "ASE",
      name: "Aspen-Pitkin County Airport",
      distance: "105 miles southwest via CO-91 and CO-82",
      address: "233 E Airport Rd, Aspen, CO 81611",
      note: "Domestic-only airport serving Aspen. Connections to DEN, DFW, ORD, ATL, LAX, SFO, IAH. Approximately 2.5-hour drive via Independence Pass (summer only) or Glenwood Springs.",
      flightUrl: "https://www.aspenairport.com/",
      flightLabel: "ASE Flight Info",
      featured: false,
    },
  ],
};